export interface Autoplay_Info {
  path: string;
  callbackFunction: (skip?: Boolean) => void;
}
export default {
  state: {
    availableClip: false,
    clip: null
  },
  getters: {
    availableClip(state: any) {
      return state.availableClip;
    },
    clip(state: any) {
      return state.clip;
    }
  },
  mutations: {
    SET_CLIP(state: any, value: Autoplay_Info) {
      state.availableClip = true;
      state.clip = value;
    },
    REMOVE_CLIP(state: any, rawName: string) {
      if (state.clip && state.clip.path == rawName) {
        state.availableClip = false;
        state.clip = null;
      }
    }
  },
  actions: {
    setClip({ commit }: any, val: Autoplay_Info) {
      commit("SET_CLIP", val);
    },
    removeClip({ commit }: any, rawName: string) {
      commit("REMOVE_CLIP", rawName);
    }
  }
};
